import { NavLink } from 'react-router-dom';

export default function Sidebar() {
  const navItems = [
    {
      id: 'resume-parser',
      label: 'Resume Parser',
      icon: '📄',
      path: '',
      enabled: true,
    },
    {
      id: 'interview-questions',
      label: 'Interview Questions Generator',
      icon: '💬',
      path: 'interview-questions',
      enabled: true,
    },
    {
      id: 'requirements-generator',
      label: 'Requirements Generator',
      icon: '📋',
      path: 'requirements',
      enabled: false,
    },
  ];

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        {navItems.map((item) => (
          item.enabled ? (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
              title={item.label}
            >
              <span className="sidebar-icon">{item.icon}</span>
              <span className="sidebar-label">{item.label}</span>
            </NavLink>
          ) : (
            <button
              key={item.id}
              className="sidebar-item disabled"
              disabled
              title="Coming soon"
            >
              <span className="sidebar-icon">{item.icon}</span>
              <span className="sidebar-label">{item.label}</span>
              <span className="sidebar-badge">Soon</span>
            </button>
          )
        ))}
      </nav>
    </aside>
  );
}
